/**
 * Owner directive 2026-08-13 (OpenRouter daily-limit outage): every user-visible
 * platform error must tell the user the failure has reached the on-call team.
 * The backend makes that sentence true — functions/src/lib/platformIncidents.ts
 * pages the internal dev channel and always writes a PLATFORM_INCIDENT log line
 * that Cloud Monitoring alerts on — so this is a statement of fact, not comfort
 * copy.
 *
 * Mirror of ONCALL_NOTICE_EN / ONCALL_NOTICE_ES in
 * functions/src/lib/platformIncidents.ts — keep the wording in lockstep.
 */
export const ONCALL_NOTICE_EN = 'This has been reported to the Prest0 on-call team.';
export const ONCALL_NOTICE_ES = 'Esto se ha informado al equipo de guardia de Prest0.';

/**
 * Append the notice to an error copy unless the text already tells the user a
 * team was told (avoids "Our team has been notified. This has been reported…"
 * stutter on copies that carry their own wording, including server-built
 * messages that arrive with the notice already attached).
 */
export function withOncallNotice(text: string): string {
  if (/notified|reported|on-call|informado|notificado|guardia/i.test(text)) return text;
  return `${text} ${ONCALL_NOTICE_EN}`;
}
